import initialState from './initialState';
import {
  FETCH_SUMMARY_FFD_SLEEP_INIT,
  FETCH_SUMMARY_FFD_SLEEP_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_FAILURE,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_INIT,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_FAILURE,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_INIT,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_FAILURE,
  FETCH_SUMMARY_FFD_SLEEP_BPM_INIT,
  FETCH_SUMMARY_FFD_SLEEP_BPM_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_BPM_FAILURE,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_INIT,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_FAILURE,
  SET_FILTER_SUMMARY_FFD_SLEEP,
  RESET_SUMMARY_FFD_SLEEP
} from '../../actions/summary_ffd_sleep/types';

export default function summaryFfdSleep(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUMMARY_FFD_SLEEP_INIT:
      return {
        ...state,
        loading: true
      };
    case FETCH_SUMMARY_FFD_SLEEP_SUCCESS:
      return {
        ...state,
        datos: action.payload.data,
        loading: false,
        status: action.payload.status
      };
    case FETCH_SUMMARY_FFD_SLEEP_FAILURE:
      return {
        ...state,
        datos: {},
        error: action.payload,
        loading: false
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_INIT:
      return {
        ...state,
        loadingTable: true
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_SUCCESS:
      return {
        ...state,
        datosTable: action.payload.data,
        loadingTable: false,
        statusTable: action.payload.status
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_FAILURE:
      return {
        ...state,
        datosTable: [],
        loadingTable: false
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_INIT:
      return {
        ...state,
        loadingTableSpiner: true
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_SUCCESS:
      return {
        ...state,
        datosTable: action.concat
          ? state.datosTable.concat(action.payload.data)
          : action.payload.data,
        loadingTableSpiner: false,
        statusTable: action.payload.status
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_FAILURE:
      return {
        ...state,
        datosTable: [],
        loadingTableSpiner: false
      };
    case FETCH_SUMMARY_FFD_SLEEP_BPM_INIT:
      return {
        ...state,
        loadingBPM: true
      };
    case FETCH_SUMMARY_FFD_SLEEP_BPM_SUCCESS:
      return {
        ...state,
        datosBPM: action.concat ? state.datosBPM.concat(action.payload.data) : action.payload.data,
        loadingBPM: false,
        statusBPM: action.payload.status
      };
    case FETCH_SUMMARY_FFD_SLEEP_BPM_FAILURE:
      return {
        ...state,
        datosBPM: [],
        loadingBPM: false
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_INIT:
      return {
        ...state,
        loadingCount: true,
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.data,
        statusCount: action.payload.status,
        loadingCount: false,
      };
    case FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_FAILURE:
      return {
        ...state,
        count: {},
        loadingCount: false,
      };
    case RESET_SUMMARY_FFD_SLEEP:
      return {
        ...initialState,
        filters: state.filters
      };
    case SET_FILTER_SUMMARY_FFD_SLEEP:
      var loadingField = action.payload.loadingField;
      var loadings = {
        loadingCount: state.loadingCount,
        loadingBPM: state.loadingBPM,
        loadingTable: state.loadingTable,
        loadingTableSpiner: state.loadingTableSpiner,
        loading: state.loading
      }

      if(loadingField && loadingField in loadings) {
        loadings[loadingField] = true;
      }

      return {
        ...state,
        ...loadings,
        filters: {
          date: {
            fechaStartFinal: action.payload.filter.date.fechaStartFinal,
            fechaEndFinal: action.payload.filter.date.fechaEndFinal
          },
          tags: action.payload.filter.tags,
          workingShiftGroup: action.payload.filter.workingShiftGroup,
          reportType: action.payload.filter.reportType,
          main: action.payload.filter.main
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/summary_ffd_sleep/index.js